module.exports = __webpack_public_path__ + "media/images/common/login_btn_ov-6972e75325e96c625f4eea52fa8d8b35.png";